import React, { useEffect, useMemo, useState } from 'react';

import { Container, Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { casesDefaultCriteria } from '../../blocs/cases.bloc';
import CaseFilters from '../../components/cases/CaseFilters';
import CaseList from '../../components/cases/CaseList';
import { defaultCase } from '../../models/Case';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const [cases, setCases] = useState([]);
  const [totalCases, setTotalCases] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState(casesDefaultCriteria);
  const [defaultCaseStatus, setDefaultCaseStatus] = useState(defaultCase);
  const [shouldOpenCreatorDashboard, setShouldOpenCreatorDashboard] = useState(false);
  const history = useHistory();
  const blocRef = useBlocRef('casesBloc');

  const handleFilterChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria({ ...updatedCriteria, page: 0 });
  };

  const [workspace, setWorkspace] = useState({});

  const handleCriteriaChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria(updatedCriteria);
  };

  const handleCaseClick = async (caseStudy) => {
    // Remove this to speed up because it seems not used for anything
    // await blocRef.current.getSelectedCase(caseStudy.id);
    history.push(`/case-details?caseId=${caseStudy.id}`);
  };

  useEffect(() => {
    const casesSub = blocRef.current.cases$.subscribe(setCases);
    const totalSub = blocRef.current.total$.subscribe(setTotalCases);
    const searchCriteriaSub = blocRef.current.searchCriteria$.subscribe(setSearchCriteria);
    const defaultCaseStatusSub = blocRef.current.defaultCase$.subscribe(setDefaultCaseStatus);
    const shouldOpenCreatorDashboardSub = blocRef.current.shouldOpenCreatorDashboard$.subscribe(setShouldOpenCreatorDashboard);
    const workspaceSub = blocRef.current.userWorkspace$.subscribe(setWorkspace);

    return () => {
      blocRef.current.dispose();
      casesSub.unsubscribe();
      totalSub.unsubscribe();
      searchCriteriaSub.unsubscribe();
      defaultCaseStatusSub.unsubscribe();
      shouldOpenCreatorDashboardSub.unsubscribe();
      workspaceSub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (shouldOpenCreatorDashboard) history.push('/creator-dashboard');
  }, [history, shouldOpenCreatorDashboard]);

  return (
    <Grid container style={{ padding: '2rem' }} component={Container}>
      <Grid item xs={12} style={{ paddingLeft: '8px' }}>
        <Typography variant="h4" align="left" className="page-header mb-1">
          Report Dashboard
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ paddingLeft: '8px' }}>
        <CaseFilters onCriteriaChange={handleFilterChange} defaultCaseStatus={defaultCaseStatus} />
      </Grid>
      <Grid item xs={12}>
        <CaseList cases={cases} total={totalCases} onCriteriaChange={handleCriteriaChange} onCaseClick={handleCaseClick} page={searchCriteria.page} workspace={workspace} />
      </Grid>
    </Grid>
  );
};
